<template>
  <NewItemShell
    :dv="dv"
    :page-title="`New ${dv.meta.model.label} Assay`"
    @save="handleSave"
  >
    <AssayView :dv="dv" />
  </NewItemShell>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useNewItemSave } from '@/composables/useNewItemSave'
import { useNewView } from '@/composables/useNewView'
import { NON_CLONABLE_ASSAY_FIELD_NAMES } from '@/constants'

import AssayView from '@/components/detail/assay/AssayView.vue'
import NewItemShell from '@/components/NewItemShell.vue'

export default {
  name: 'AssayNewView',
  components: {
    NewItemShell,
    AssayView,
  },
  props: {
    appName: {
      type: String,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
    modelType: {
      type: String,
      default: '',
    },
    cloneData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute()

    const dv = useNewView({
      appName: props.appName,
      modelName: props.modelName,
      modelType: props.modelType,
      cloneData: props.cloneData?.id ? props.cloneData : null,
      nonClonableFieldNames: NON_CLONABLE_ASSAY_FIELD_NAMES,
      postCloneTransform: (data) => {
        // Delete IDs from channels
        if (data.channels?.value?.length > 0) {
          data.channels.value.forEach((ch) => delete ch.id)
        }
        // Normalize protocol_list
        const protocolList = data['protocol_list']?.value?.protocols
        if (protocolList) {
          data['protocol_list'].value = { protocols: protocolList }
        }
        // Add " copy" suffix to name
        if (data.name?.value?.name) {
          data.name.value = {
            ...data.name.value,
            name: `${data.name.value.name} copy`,
          }
        }
      },
    })

    // Override validation: templates bypass validation
    const hasValidationErrors = computed(() => {
      if (dv.record?.is_template?.value) return false
      return dv.hasValidationErrors
    })
    dv.hasValidationErrors = hasValidationErrors

    const { handleSave } = useNewItemSave(dv, {
      getRoute: (res) => {
        const assayId = res.id.value
        const queryLoader = route.query.load

        if (queryLoader === true || queryLoader === 'true') {
          return { name: 'loader', query: { assayId } }
        }

        const params = {
          id: assayId,
          appName: props.appName,
          modelName: props.modelName,
          modelType: props.modelType,
        }

        if (props.cloneData?.keepAnnotations) {
          params.loadAnnotationsFrom = {
            appName: props.appName,
            modelName: props.modelName,
            id: props.cloneData.id,
          }
        }

        return {
          name: 'assayDetail',
          params,
          query: { edit: 'true' },
        }
      },
    })

    return { dv, handleSave }
  },
}
</script>
